import { render } from "./apply-template.vue?vue&type=template&id=03f0a564&lang=pug"
import script from "./apply-template.vue?vue&type=script&lang=js"
export * from "./apply-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__